import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const DocumentModifiedIcon = (props: SvgIconT.Props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g transform="translate(2 3)">
      <path d="M17 5h-2.798C13.54 5 13 4.46 13 3.798V1h1v2.798c0 .111.09.202.202.202H17v1Z" />
      <path d="m17.707 3.693-3.4-3.4A1 1 0 0 0 13.6 0H4a1 1 0 0 0-1 1v1.5h1V1h9.6L17 4.4V18H4v-1.5H3V18a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V4.4a1 1 0 0 0-.293-.707Z" />
      <circle cx={3.5} cy={2.5} r={1} />
      <circle cx={3.5} cy={16.5} r={1} />
      <path d="m5.5 5 4.5 8H1l4.5-8m0-1a1 1 0 0 0-.872.51l-4.5 8A1 1 0 0 0 1 14h9a1 1 0 0 0 .872-1.49l-4.5-8A1 1 0 0 0 5.5 4Z" />
    </g>
  </SvgIcon>
);

export default DocumentModifiedIcon;
